import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

// 前台的標籤
export const getTags = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/get-tags`,
  body: info
});

export const getMemberList = (paginationInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/get-member-list`,
  body: paginationInfo
});

export const storeTag = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/store`,
  body: storeInfo
});

export const showTag = (showInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/show`,
  body: showInfo
});

export const updateTag = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/update`,
  body: updateInfo
});

export const destroyTag = (tagInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-tag/destroy`,
  body: tagInfo
});

// 後台的標籤
export const getBackendTags = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-backend-tag/get-tags`,
  body: info
});

export const getBackendMemberList = (paginationInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-backend-tag/get-member-list`,
  body: paginationInfo
});

export const showBackendTag = (showInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-backend-tag/show`,
  body: showInfo
});

export const updateBackendTag = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/personnel-backend-tag/update`,
  body: updateInfo
});
